const ScoreDisplay = ({ score }) => {
    return (
        <div className="info-display">
            Score: 
            <p>{ score }</p>
        </div>
    )
};

export default ScoreDisplay;
